(function (window, angular, undefined) {
    angular.module('formApp')
        .directive("copsIframe", ['$compile', '$rootScope', '$window', function ($compile, $rootScope, $window) {
            function link($scope, element, attrs, a, b, c, d) {
                console.log("directive 123");
                $rootScope.$on('cops-loaded', function (event, args) {
                    console.log("directive");
                    var copsIframe = angular.element("<iframe id='copsIframe'/>");
                    element.append(copsIframe);

                    var myIFrame = document.getElementById("copsIframe");

                    myIFrame = (myIFrame.contentWindow) ? myIFrame.contentWindow : (myIFrame.contentDocument.document) ? myIFrame.contentDocument.document : myIFrame.contentDocument;
                    myIFrame.document.open();
                    myIFrame.document.write($scope.cops);
                    myIFrame.document.close(); 

                    myIFrame.addEventListener("DOMAttrModified", function(event) {
                        console.log('new',event);
                        if (event.attrName === "src") {
                            console.log('if',event);
                        }

                    });
                    window.addEventListener("message", function (event) {

                            console.log("event for cops",event);
                        if (event.data === "0") {
                            $rootScope.$broadcast('cops-success');
                            $scope.paymentButtonDisabled = false;
                            copsIframe.remove();
                        }
                        else if (event.data === "8") {
                            $rootScope.$broadcast('cops-error',{ errortype: "pop", errorcode:"B"});
                            $scope.paymentButtonDisabled = false;
                            copsIframe.remove();
                        }
                        else {
                        
                            $rootScope.$broadcast('cops-error',{ errortype: "pop", errorcode:"A"});
                            $scope.paymentButtonDisabled = false;
                            copsIframe.remove();
                        }
                        
                    });

                });
            }
            return {
                link: link,
                restrict: 'E'
            };
        }]);
})(window, window.angular);